export enum TableAction{
    Opportunity=1,
    Task=2,
    SendEmail=3,
    SendSms=4
  }